<template>
    <el-dialog width="504px"
               :visible.sync="isShow"
               title="新增服务"
               top="182px"
               append-to-body
               :close-on-click-modal="false">
        <el-form :model="service" label-width="100px" ref="form">
            <el-form-item label="服务ID" prop="id" :rules="[{required: true, message: '请输入服务ID', trigger: 'blur'}, {validator: formatServeId, trigger: 'blur'}]">
                <div :style="{width: '336px'}">
                    <el-input v-model="service.id" placeholder="请输入服务ID"
                              maxlength="50" @focus="showTip1 = true" @blur="showTip1 = false"
                    ></el-input>
                    <p :style="{fontSize: '12px', color: '#999999', lineHeight: '24px'}" v-if="showTip1">输入值小于50位，只允许字母、数字、下划线的字符组合；输入以字母开头</p>
                </div>
            </el-form-item>
            <el-form-item label="服务类型" prop="type" :rules="[{required: true, message: '请输入服务类型', trigger: 'blur'}, {validator: formatServeType, trigger: 'blur'}]">
                <div :style="{width: '336px'}">
                    <el-input v-model="service.type" placeholder="请输入服务类型" maxlength="50" @focus="showTip2 = true" @blur="showTip2 = false"></el-input>
                    <p :style="{fontSize: '12px', color: '#999999', lineHeight: '24px'}" v-if="showTip2">输入值小于50位，只允许字母、数字、下划线的字符组合；输入以字母开头</p>
                </div>
            </el-form-item>
            <el-form-item label="服务描述" prop="description">
                <div :style="{width: '336px'}">
                    <el-input v-model="service.description" type="textarea"
                              show-word-limit
                              :rows="6"
                              class="add-serve-textarea"
                              placeholder="请输入服务描述" maxlength="1024"></el-input>
                </div>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button plain size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="confirm" :style="{marginLeft: '24px'}">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {isServiceId2, isServiceId} from "../../assets/js/utils";

    export default {
        name: "addServiceDialog",
        data() {
            return {
                isShow: false,
                resolve: null,
                names: [],
                service: {
                    id: '',
                    type: '',
                    description: '',
                },
                showTip1: false,
                showTip2: false,

            }
        },
        watch: {
            isShow(v) {
                if (!v) {
                    this.resolve && this.resolve(null)
                    this.resolve = null
                    this.$refs.form.clearValidate();
                }
            }
        },
        methods: {
            formatServeId(rule, value, callback) {
                if (!isServiceId2(value)) {
                    callback(new Error('服务ID必须以字母开头'))
                    return
                }
                if (!isServiceId(value)) {
                    callback(new Error('服务ID只允许字母、数字、下划线、连字符的字符组合'))
                    return
                }
                if (this.names.includes(value)) {
                    callback(new Error('服务ID重复'))
                    return
                }
                callback()
            },
            formatServeType(rule, value, callback) {
                if (!isServiceId2(value)) {
                    callback(new Error('服务类型必须以字母开头'))
                }
                if (!isServiceId(value)) {
                    callback(new Error('服务类型只允许字母、数字、下划线、连字符的字符组合'))
                }
                callback()
            },
            initData() {
                this.service = {
                    id: '',
                    type: '',
                    description: '',
                };
                this.showTip1 = false;
                this.showTip2 = false;
            },
            async show({names}) {
                this.initData();
                this.names = names;
                this.isShow = true;
                return new Promise(resolve => {
                    this.resolve = resolve;
                } )
            },
            cancel() {
                this.resolve && this.resolve(null);
                this.resolve = null;
                this.isShow = false;
            },
            async confirm() {
                await this.$refs.form.validate();
                this.resolve && this.resolve(this.service);
                this.isShow = false;
            }
        },
    }
</script>

<style scoped>
    .btns{
        text-align: center;
        padding-top: 15px;
    }
</style>
<style>
    .add-serve-textarea textarea{
        padding-right: 75px!important;
    }
</style>